import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { getTrackingPageBlocks, Loading, TrackingPageGrid, useTrackingPageLayout } from '@reveni-io/reveni-ui'

import useOrderTrackingInfo from './hooks/useOrderTrackingInfo/useOrderTrackingInfo'
import { blockDefinitions } from './helpers'

const TrackingPage = () => {
  const { t } = useTranslation()
  const { orderId } = useParams()
  const { orderTrackingInfo, fetchingOrderTrackingInfo } = useOrderTrackingInfo({ orderId })
  const { viewMode, layout, blockSettings, handleBlockHeightChange } = useTrackingPageLayout({
    savedLayout: orderTrackingInfo?.layout,
  })

  if (fetchingOrderTrackingInfo || !layout) {
    return <Loading show />
  }

  const blocks = getTrackingPageBlocks({ layout, blockDefinitions, orderTrackingInfo, t, blockSettings })

  return (
    <TrackingPageGrid
      blocks={blocks}
      viewMode={viewMode}
      layout={layout}
      onBlockHeightChange={handleBlockHeightChange}
    />
  )
}

export default TrackingPage
